<template>
  <v-navigation-drawer v-model="isSidebarActiveLocal" absolute temporary width="300" right>
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <v-card class="mb-7">
        <v-card-text class="pa-5 ">
          <div class="d-flex align-center text-center">
            <h3 class="title orange--text">{{title}}</h3>
          </div>

          <v-row class="mt-3">
            <v-col cols="12">
              <ValidationProvider rules="required" v-slot="{ errors }" name="name">
                <v-text-field
                        label="Nome"
                        :error-messages="errors"
                        v-model="label.name"
                        rel="initialFocus"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider rules="required" v-slot="{ errors }" name="color">
                <v-text-field v-model="color" readonly :error-messages="errors"  class="ma-0 pa-0" solo>
                  <template v-slot:append>
                    <v-menu v-model="menu" top nudge-bottom="105" nudge-left="16" :close-on-content-click="true">
                      <template v-slot:activator="{ on }">
                        <div :style="swatchStyle" v-on="on" />
                      </template>
                      <v-card>
                        <v-card-text class="pa-0">
                          <v-color-picker
                                  value="#7417BE"
                                  v-model="color"
                                  hide-canvas
                                  mode="hexa"
                                  disabled
                                  :swatches="swatches"
                                  show-swatches
                                  hide-inputs
                                  class="mx-auto no-alpha"
                          ></v-color-picker>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </template>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider  v-slot="{ errors }" name="parent">
                <v-select
                        :items="labels"
                        label="Etiqueta Pai"
                        dense
                        :error-messages="errors"
                        item-text="name"
                        item-value="id"
                        v-model="parent"
                        no-data-text="Nenhum dado disponível"
                ></v-select>

              </ValidationProvider>
            </v-col>
          </v-row>
        </v-card-text>
        <div  class="text-center">
          <buttons-form-side @onCreateSubmit="passes(createSubmit)" @onUpdateSubmit="passes(updateSubmit)" @cancel="cancelar"  :operation="operation" ></buttons-form-side>
        </div>
      </v-card>
    </ValidationObserver>
  </v-navigation-drawer>
</template>
<script>
    // import VSwatches from 'vue-swatches'
    import { CreateMutation, UpdateMutation } from "@/graphql/mutations/Label.gql";
    import ButtonsFormSide from "@/components/appComponents/ButtonsFormSide";
    import NotificationForm from "@/mixins/notification-form";
    import { ValidationObserver, ValidationProvider } from "vee-validate";
    export default {
    name: "ClientList",
    mixins:[NotificationForm],
    props: {
        isSidebarActive: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
        },
        data: {
            type: Object,
            required: true,
        },
        operation: {
            type: String,
            required: true,
        },
    },
    components: {
        ValidationObserver,
        ValidationProvider,
     ButtonsFormSide

    },
    data: () => {
        return {
            label: {},
            swatches: [
                ['#ff0000', '#aa0000', '#550000'],
                ['#FFFF00', '#AAAA00', '#555500'],
                ['#00FF00', '#00AA00', '#005500'],
                ['#00FFFF', '#00AAAA', '#005555'],
                ['#0000FF', '#1976D2FF', '#000055'],
            ],
            color: '#1976D2FF',
            menu: false,
            parent:'',
            labels:[],
        };
    },

    computed: {
        swatchStyle() {
            const {color, menu} = this
            return {
                backgroundColor: color,
                cursor: 'pointer',
                height: '30px',
                width: '30px',
                borderRadius: menu ? '50%' : '4px',
                transition: 'border-radius 200ms ease-in-out'
            }
        },
        isSidebarActiveLocal: {

            get() {
                this.setLocalData();
                return this.isSidebarActive;
            },
            set(val) {
                if (!val) {
                    this.$emit("closeSidebar");
                }
            },
        },
        dataSubmit() {
            const data = {
                name: this.label.name,
                color: this.color,
                parent: this.parent,
            }
            return data;
        },
    },
    methods: {
     cancelar(valor){
      this.isSidebarActiveLocal = valor
     },
        setLocalData() {
            this.label = this.data
            this.parent = this.data.parent
            if(this.operation === 'update') {
                this.color = this.data.color
            }
        },
        clear() {
            this.isSidebarActiveLocal = false;
        },
        createSubmit() {
            this.$apollo
                .mutate({
                    mutation: CreateMutation,
                    variables: {
                        ...this.dataSubmit,
                    },
                })
                .then(() => {

                 this.showCreateMessage()
                    this.$emit("reload-list");
                    this.clear();
                })
              .catch((error)=>{
               this.showErrorMessage(error)
              })

        },
        updateSubmit() {
            this.$apollo
                .mutate({
                    mutation: UpdateMutation,
                    variables: {
                        id: this.label.id,
                        ...this.dataSubmit,
                    },
                })
                .then(() => {
                 this.showUpdateMessage()
                    this.$emit("reload-list");
                    this.clear();
                })
              .catch((error)=>{
               console.error(error.graphQLErrors)
               this.showErrorMessage(error)
              })
        },
    },
    apollo: {
        labels: {
            query: require('@/graphql/queries/Label.gql').getLabels,
            update: (data) => data.labels

        }
    },
    mounted() {
        this.$el.querySelector("input").focus();
    },
  };
</script>